import { Button, SolvTheme, Stack, Text } from '@solvhealth/jigsaw-v1';
import Booking from '@solvhealth/types/interfaces/Booking';
import Location from '@solvhealth/types/interfaces/Location';
import React, { Component } from 'react';
import {
  ADD_REVIEW_TO_SOLV,
  DO_YOU_HAVE_GOOGLE_ACCOUNT,
  NPS_AND_ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE,
} from '../../../constants/index';

import ReviewHeader from '~/components/AddReview/ReviewHeader';
import {
  ADD_REVIEW_LEAVE_REVIEW_ON_GOOGLE,
  ADD_REVIEW_NO_GOOGLE_ACCOUNT,
} from '../../../core/analytics/events';
import { analyticsTrackEvent } from '../../../core/analytics/index';
import AddReviewWarning from '../AddReviewWarning';
import FlowTransition from '../transitions/FlowTransition';
import { goToGoogleReviewFlow } from '~/core/dapi/tracking';

const FIVE_STAR = 5;

type Props = {
  bookingId: string;
  booking: Booking;
  location: Location;
  handleRatingChange: (...args: any[]) => any;
  setFlowState: (...args: any[]) => any;
  review: string;
  error?: any;
  flowState: string;
  googleUrl: string;
  isSubmitting: boolean;
  starRating?: number;
  submitReview: (...args: any[]) => any;
  hasRecommendedClinic?: boolean;
  leaveAReview: any;
};

class AskIfHaveGoogleAccount extends Component<Props> {
  handleDoYouHaveAGoogleAccountYes = () => {
    const trackingProperties = {
      locationId: this.props.location.id,
      flowType: NPS_AND_ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE,
      starRating: this.props.starRating,
      review: this.props.review,
      bookingId: this.props.bookingId,
    };
    analyticsTrackEvent(ADD_REVIEW_LEAVE_REVIEW_ON_GOOGLE, trackingProperties);

    this.props.submitReview(
      {
        locationId: this.props.location.id,
        bookingId: this.props.bookingId,
        providerId: this.props.booking.providerId,
        starRating: this.props.leaveAReview['primary rating'],
        hasRecommendedClinic: this.props.hasRecommendedClinic,
        hasClickedReviewOnGoogle: true,
      },
      false
    );

    goToGoogleReviewFlow(this.props.googleUrl!, this.props.bookingId);
    return null;
  };

  handleDoYouHaveAGoogleAccountNo = () => {
    const trackingProperties = {
      locationId: this.props.location.id,
      flowType: NPS_AND_ADD_REVIEW_FLOW_RECOMMEND_TO_GOOGLE,
      starRating: this.props.starRating,
      review: this.props.review,
      bookingId: this.props.bookingId,
    };
    analyticsTrackEvent(ADD_REVIEW_NO_GOOGLE_ACCOUNT, trackingProperties);

    this.props.submitReview(
      {
        locationId: this.props.location.id,
        bookingId: this.props.bookingId,
        providerId: this.props.booking.providerId,
        starRating: this.props.leaveAReview['primary rating'],
        hasRecommendedClinic: this.props.hasRecommendedClinic,
        hasClickedReviewOnGoogle: false,
      },
      false
    );

    this.props.handleRatingChange(FIVE_STAR);

    this.props.setFlowState(ADD_REVIEW_TO_SOLV);
  };

  renderDoYouHaveAGoogleAccount = () => (
    <div>
      <ReviewHeader booking={this.props.booking} location={this.props.location} />

      <AddReviewWarning error={this.props.error} ratingDate={this.props.booking?.ratingDate} />
      <Stack
        alignItems="center"
        maxWidth={SolvTheme.breakpoints.sm}
        mx="auto"
        px={2}
        space={4}
        textAlign="center"
      >
        <Stack alignItems="center" py={4} space={2} textAlign="center">
          <img src="/images/icons/google-icon.svg" width={70} />

          <Text variant="h2">Do you have a google account?</Text>
        </Stack>

        <Stack alignItems="center" row space={1}>
          <Button onClick={this.handleDoYouHaveAGoogleAccountYes} variant="outlined">
            Yes
          </Button>

          <Button onClick={this.handleDoYouHaveAGoogleAccountNo} variant="outlined">
            No
          </Button>
        </Stack>
      </Stack>
    </div>
  );

  render() {
    return (
      <FlowTransition
        flowState={this.props.flowState}
        stateToActivateFlow={DO_YOU_HAVE_GOOGLE_ACCOUNT}
        toRender={this.renderDoYouHaveAGoogleAccount}
      />
    );
  }
}

export default AskIfHaveGoogleAccount;
